module.exports = __webpack_public_path__ + "static/img/qq.5040ebae.png";